/* istanbul ignore file */
import { useRef } from 'react';
import { OfferSessionService } from './buyer-offer-session';

export function useOfferSession() {
    const offerSession = useRef(new OfferSessionService());
    return offerSession.current;
}
